const SYMBOLS: Record<string, string> = {
  usd: '$',
  eur: '€',
  chf: 'CHF ',
};

export const getCurrencySymbol = (currency: string): string =>
  SYMBOLS[currency?.toLowerCase()] ?? '';
